import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { SITE_BRAND, SITE_ORIGIN } from '@/config/site'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const canonical = (path) => `${SITE_ORIGIN}${path}`

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: SITE_BRAND,
			title: 'GB WhatsApp APK v18.80 Download Latest Version 2026 (Anti-Ban)',
			keywords: `GB WhatsApp APK, Android APK file, ${SITE_BRAND}, install guide`,
			description: 'Download GB WhatsApp with the latest APK file for Android. Get GBWhatsApp installation guide and version details here.',
			link: [{ rel: 'canonical', href: canonical('/') }],
		},
		component: Home,
	},
	{
		path: '/download/',
		// 无斜杠仅作兼容匹配，正式地址与 named 跳转均带尾斜杠
		alias: '/download',
		name: 'en-download',
		meta: {
			appname: SITE_BRAND,
			title: 'Safe Page to Get GBWhatsApp APK File',
			keywords: 'GB WhatsApp APK, GB WhatsApp Download, Download GB WhatsApp, GB WhatsApp APK file',
			description: 'This is a safe page for you to install new updated GB WhatsApp APK. Free to download GB WhatsApp on your phone.',
			link: [{ rel: 'canonical', href: canonical('/download/') }],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/gb-whatsapp-update/',
		alias: '/gb-whatsapp-update',
		name: 'en-update',
		meta: {
			appname: SITE_BRAND,
			title: 'GB WhatsApp Update: Download the Latest Version APK',
			keywords: 'GB WhatsApp Update, GB WhatsApp latest update, GB WhatsApp latest version APK',
			description: 'Get the latest GB WhatsApp update with new features, version information, update instructions, and answers to common update questions.',
			link: [{ rel: 'canonical', href: canonical('/gb-whatsapp-update/') }],
		},
		component: () => import('@/views/update.vue'),
	},
	{
		path: '/gb-whatsapp-old-version/',
		alias: '/gb-whatsapp-old-version',
		name: 'en-old-version',
		meta: {
			appname: SITE_BRAND,
			title: 'GB WhatsApp Old Version APK – Previous Releases',
			keywords: 'GB WhatsApp old version, GB WhatsApp v18.70, GB WhatsApp v18.60, previous GB WhatsApp APK',
			description:
				'Looking for GB WhatsApp v18.70 or v18.60? Check previous version details, APK availability, and what to consider before installing an older release.',
			link: [{ rel: 'canonical', href: canonical('/gb-whatsapp-old-version/') }],
		},
		component: () => import('@/views/gb-whatsapp-old-version.vue'),
	},
	{
		path: '/guides/',
		alias: '/guides',
		name: 'en-guides',
		meta: {
			appname: SITE_BRAND,
			title: 'GB WhatsApp Guides & Tutorials (2026)',
			keywords: 'GB WhatsApp guides, GB WhatsApp tutorials, GB WhatsApp privacy settings, GB WhatsApp troubleshooting',
			description: 'Explore GB WhatsApp guides and tutorials, including installation, privacy settings, feature tips, updates, backups, and troubleshooting.',
			link: [{ rel: 'canonical', href: canonical('/guides/') }],
		},
		component: () => import('@/views/guides.vue'),
	},
	{
		path: '/disable-blue-ticks-in-gb-whatsapp/',
		alias: '/disable-blue-ticks-in-gb-whatsapp',
		name: 'en-disable-blue-ticks',
		meta: {
			appname: SITE_BRAND,
			title: 'How to Disable Blue Ticks in GB WhatsApp Pro (Hide Read Receipts)',
			keywords: 'disable blue ticks GB WhatsApp Pro, hide read receipts GB WhatsApp, GB WhatsApp privacy settings',
			description: 'Learn how to disable blue ticks in GB WhatsApp Pro and read messages without showing read receipts. Follow simple privacy settings steps.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/disable-blue-ticks-in-gb-whatsapp/'),
				},
			],
		},
		component: () => import('@/views/disable-blue-ticks-in-gb-whatsapp.vue'),
	},
	{
		path: '/how-to-share-location-on-gb-whatsapp/',
		alias: '/how-to-share-location-on-gb-whatsapp',
		name: 'en-share-location',
		meta: {
			appname: SITE_BRAND,
			title: 'How to Share Location on GB WhatsApp (Live Location Guide)',
			keywords: 'share location GB WhatsApp, GB WhatsApp live location, GB WhatsApp location guide',
			description: 'Learn how to share live location and current location on GB WhatsApp. Follow simple steps to send your location and manage privacy settings.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/how-to-share-location-on-gb-whatsapp/'),
				},
			],
		},
		component: () => import('@/views/how-to-share-location-on-gb-whatsapp.vue'),
	},
	{
		path: '/hide-online-status-gbwhatsapp-pro/',
		alias: '/hide-online-status-gbwhatsapp-pro',
		name: 'en-hide-online-status',
		meta: {
			appname: SITE_BRAND,
			title: 'How to Hide Online Status in GB WhatsApp Pro',
			keywords: 'hide online status GB WhatsApp Pro, GB WhatsApp privacy, GB WhatsApp last seen',
			description:
				'Hide your online status in GB WhatsApp Pro to get more privacy while chatting. Find the relevant settings and understand what others can still see.',
			link: [{ rel: 'canonical', href: canonical('/hide-online-status-gbwhatsapp-pro/') }],
		},
		component: () => import('@/views/hide-online-status-gbwhatsapp-pro.vue'),
	},
	{
		path: '/restore-deleted-messages-gb-whatsapp/',
		alias: '/restore-deleted-messages-gb-whatsapp',
		name: 'en-restore-deleted-messages',
		meta: {
			appname: SITE_BRAND,
			title: 'How to Restore Deleted Messages in GB WhatsApp Pro',
			keywords: 'restore deleted messages GB WhatsApp Pro, GB WhatsApp backup, recover GB WhatsApp chats',
			description:
				'Deleted messages in GB WhatsApp Pro? Check your chat backups, follow the available restore options, and find out what you can recover without a backup.',
			link: [{ rel: 'canonical', href: canonical('/restore-deleted-messages-gb-whatsapp/') }],
		},
		component: () => import('@/views/restore-deleted-messages-gb-whatsapp.vue'),
	},
	{
		path: '/how-to-lock-individual-chats-in-gb-whatsapp/',
		alias: '/how-to-lock-individual-chats-in-gb-whatsapp',
		name: 'en-lock-individual-chats',
		meta: {
			appname: SITE_BRAND,
			title: 'How to Lock Individual Chats in GB WhatsApp',
			keywords: 'lock individual chats GB WhatsApp, GB WhatsApp chat lock, hide GB WhatsApp chats',
			description: 'Lock individual chats in GB WhatsApp with a PIN, password, pattern, or fingerprint to keep private conversations hidden from your main chat list.',
			link: [
				{
					rel: 'canonical',
					href: canonical('/how-to-lock-individual-chats-in-gb-whatsapp/'),
				},
			],
		},
		component: () => import('@/views/how-to-lock-individual-chats-in-gb-whatsapp.vue'),
	},
	{
		path: '/about-us/',
		alias: '/about-us',
		name: 'en-about',
		meta: {
			pageKey: 'about',
			title: `About Us - ${SITE_BRAND}`,
			description: `Learn about ${SITE_BRAND}, an independent GB WhatsApp resource website for APK information, guides, and update notes.`,
			link: [{ rel: 'canonical', href: canonical('/about-us/') }],
		},
		component: () => import('@/views/footerPage.vue'),
	},
	{
		path: '/contact-us/',
		alias: '/contact-us',
		name: 'en-contact',
		meta: {
			pageKey: 'contact',
			title: `Contact Us - ${SITE_BRAND}`,
			description: `Contact ${SITE_BRAND} for website questions, content corrections, and outdated GB WhatsApp APK information reports.`,
			link: [{ rel: 'canonical', href: canonical('/contact-us/') }],
		},
		component: () => import('@/views/footerPage.vue'),
	},
	{
		path: '/privacy-policy/',
		alias: ['/privacy-policy', '/privacy/', '/privacy'],
		name: 'en-privacy',
		meta: {
			pageKey: 'privacy',
			title: `Privacy Policy - ${SITE_BRAND}`,
			description: `Read the ${SITE_BRAND} Privacy Policy and learn how this independent resource website handles basic website information.`,
			link: [{ rel: 'canonical', href: canonical('/privacy-policy/') }],
		},
		component: () => import('@/views/footerPage.vue'),
	},
	{
		path: '/terms-of-use/',
		alias: '/terms-of-use',
		name: 'en-terms',
		meta: {
			pageKey: 'terms',
			title: `Terms of Use - ${SITE_BRAND}`,
			description: `Read the ${SITE_BRAND} Terms of Use for this independent GB WhatsApp APK information and guide website.`,
			link: [{ rel: 'canonical', href: canonical('/terms-of-use/') }],
		},
		component: () => import('@/views/footerPage.vue'),
	},
	{
		path: '/disclaimer/',
		alias: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			pageKey: 'disclaimer',
			title: `Disclaimer - ${SITE_BRAND}`,
			description: `Read the ${SITE_BRAND} disclaimer about independent GB WhatsApp information, modified app risks, and non-affiliation.`,
			link: [{ rel: 'canonical', href: canonical('/disclaimer/') }],
		},
		component: () => import('@/views/footerPage.vue'),
	},
]

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes: constRoutesPc,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})

	// Vue Router 3 生成/匹配时常丢掉尾斜杠；用 replaceState 只改地址栏，不触发再次导航（避免死循环）
	router.afterEach(() => {
		if (typeof window === 'undefined') return
		const { pathname, search, hash } = window.location
		if (pathname.length > 1 && !pathname.endsWith('/') && !/\.[a-zA-Z0-9]+$/.test(pathname)) {
			window.history.replaceState(window.history.state, '', `${pathname}/${search}${hash}`)
		}
	})

	return router
}
